/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
;(function () {
	const siteNavigation = document.getElementById('site-navigation')

	// Return early if the navigation doesn't exist.
	if (!siteNavigation) {
		return
	}

	const button = siteNavigation.getElementsByTagName('button')[0]

	// Return early if the button doesn't exist.
	if ('undefined' === typeof button) {
		return
	}

	const menu = siteNavigation.getElementsByTagName('ul')[0]

	// Hide menu toggle button if menu is empty and return early.
	if ('undefined' === typeof menu) {
		button.style.display = 'none'
		return
	}

	if (!menu.classList.contains('nav-menu')) {
		menu.classList.add('nav-menu')
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener('click', function () {
		siteNavigation.classList.toggle('toggled')

		if ('true' === button.getAttribute('aria-expanded')) {
			button.setAttribute('aria-expanded', 'false')
		} else {
			button.setAttribute('aria-expanded', 'true')
		}
	})

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener('click', function (event) {
		const isClickInside = siteNavigation.contains(event.target)

		if (!isClickInside) {
			siteNavigation.classList.remove('toggled')
			button.setAttribute('aria-expanded', 'false')
		}
	})

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName('a')

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll(
		'.menu-item-has-children > a, .page_item_has_children > a'
	)

	// Toggle focus each time a menu link is focused or blurred.
	for (const link of links) {
		link.addEventListener('focus', toggleFocus, true)
		link.addEventListener('blur', toggleFocus, true)
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for (const link of linksWithChildren) {
		link.addEventListener('touchstart', toggleFocus, false)
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if ('focus' === event.type || 'blur' === event.type) {
			let self = this

			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (!self.classList.contains('nav-menu')) {
				// On li elements toggle the class .focus.
				if ('li' === self.tagName.toLowerCase()) {
					self.classList.toggle('focus')
				}
				self = self.parentNode
			}
		}

		if ('touchstart' === event.type) {
			const menuItem = this.parentNode
			event.preventDefault()
			for (const link of menuItem.parentNode.children) {
				if (menuItem !== link) {
					link.classList.remove('focus')
				}
			}
			menuItem.classList.toggle('focus')
		}
	}
})()

document.addEventListener('DOMContentLoaded', () => {
	// Get all "navbar-burger" elements
	const $dropdowns = Array.prototype.slice.call(
		document.querySelectorAll('.menu-item.has-dropdown'),
		0
	)

	// Check if there are any dropdown items
	if (0 < $dropdowns.length) {
		// Add a click event on each of them
		$dropdowns.forEach((el) => {
			el.addEventListener('click', () => {
				if (mediaQueryList.matches) {
					// Get the target from the "data-target" attribute
					// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
					el.classList.toggle('is-active')
				}
			})
		})
	}
	// Get all "navbar-burger" elements
	const $navbarBurgers = Array.prototype.slice.call(
		document.querySelectorAll('.navbar-burger'),
		0
	)

	// Check if there are any navbar burgers
	if ($navbarBurgers.length > 0) {
		// Add a click event on each of them
		$navbarBurgers.forEach((el) => {
			el.addEventListener('click', () => {
				// Get the target from the "data-target" attribute
				const target = el.dataset.target
				const $target = document.getElementById(target)

				// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
				el.classList.toggle('is-active')
				$target.classList.toggle('is-active')
			})
		})
	}

	// Create Mobile Breakpoint to clean up nav
	const mediaQueryList = window.matchMedia('(max-width: 1280px)')

	mediaQueryList.addEventListener('change', (event) => {
		if (!event.matches) {
			Array.from(document.querySelectorAll('.navbar .is-active')).forEach(
				(el) => el.classList.remove('is-active')
			)
		}
	})
})
